import {createFileRoute, redirect} from '@tanstack/react-router'

export const Route = createFileRoute('/_app/quotes/scheduling')({
    beforeLoad: () => {
        throw redirect({to: '/quotes'})
    },
})
